import moment from 'moment';
import zxcvbn from 'zxcvbn';
import _ from 'lodash';
import formatCurrency from "format-currency";

class ChargecodeCreateController {

  constructor(CompanyService, toastr, $scope, $http, $rootScope, $stateParams, $state) {
    "ngInject";

    let self = this;

    this.moment = moment;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.state = $state;
    this.$stateParams = $stateParams;
    this.activeUsers = [];

    this.payrollCostCategoryOptions = [
      { value: null, text: '(unset)' },
      { value: 'DIRECT', text: 'Direct' },
      { value: 'FRINGE', text: 'Fringe' },
      { value: 'OVERHEAD', text: 'Overhead' },
      { value: 'GENERAL_ADMINISTRATIVE', text: 'General & Administrative' },
      { value: 'BID_AND_PROPOSAL', text: 'B&P' }
    ];

    this.initializeData();

    this.wizard =  {
      show: function(number) {
        self.step = number;
      },
      next: function() {
        self.step++ ;
      },
      prev: function() {
        self.step-- ;
      }
    };

  }

  loadContractsForCustomer() {
    let self = this;
    this.contractFilter = 'none';
    this.taskFilter = 'none';
    this.laborRateFilter = 'none';
    this.popRateFilter = 'none';
    this.projectsForContract = [];

    self.contractsForCustomer = [];

    if(this.customerFilter && this.customerFilter !== 'none') {
      this.$http.get(this.$rootScope.apiHost+"/api/admin/contracts/bycustomer?customer="+this.customerFilter.id, {withCredentials: true}).then(function (success) {

      if (self.useType === 'subcontractor') {
        success.data.forEach(function (contract) {
          if(contract.allowSubcontracting) {
            self.contractsForCustomer.push(contract);
          }
        });
      } else {
        self.contractsForCustomer = success.data;
      }



      });
    }
  }

  loadProjectsForContract(){
    let self = this;
    self.projectsForContract = [];
    self.subcontractorsForContract = [];

    if(this.contractFilter && this.contractFilter !== 'none') {
      this.$http.get(this.$rootScope.apiHost+"/api/admin/projects/bycontract?contract="+this.contractFilter.id, {withCredentials: true}).then(function (success) {
        self.projectsForContract = success.data;
      });

      this.$http.get(this.$rootScope.apiHost+"/api/admin/contracts/"+self.contractFilter.id+"/laborrates", {withCredentials: true}).then(function (success) {
        self.laborRatesForContract = success.data;
      });


      this.subcontractsForContract = [];

      this.$http.get(self.$rootScope.apiHost+'/api/admin/subcontractors', {withCredentials: true}).then(function (success) {
        success.data.forEach(function (subcontractor){
          subcontractor.subcontracts.forEach(function (subcontract) {
            if(subcontract.associatedContract.id === self.contractFilter.id) {
              self.subcontractsForContract.push(subcontract);
            }
          })
        });
      });

    }
  }


  getContracts() {
    if(this.customerFilter && this.customerFilter != 'none') {
      let contracts = {};
      this.$http.get(this.$rootScope.apiHost+"/api/admin/contracts/bycustomer?customerId="+this.customerFilter.id, {withCredentials: true}).then(function (success) {
        contracts = success.data;
      });

      return contracts;
    }

    this.contractFilter = 'none';
    this.taskFilter = 'none';
    return undefined;
  }

  getProjects() {
    if(this.contractFilter && this.contractFilter !== 'none') {
      return this.contractFilter.tasks;
    }

    this.taskFilter = 'none';
    return undefined;
  }

  getPops() {
    if(this.laborRateFilter && this.laborRateFilter !== 'none') {
      return this.contractFilter.periodsOfPerformance;
    }

    this.popRateFilter = 'none';
    return undefined;
  }

  internalCodeFormValid() {
    // if(this.chargecode.leaveType === 'false'  && this.chargecode.payable !== undefined) {
    //   return true;
    // } else {
    //   return this.chargecode.associatedLeaveType !== 'none' && this.chargecode.payable !== undefined;
    // }
    if (this.chargecode.payable === undefined) {
      return false
    }

    return true
  }

  projectFormValid(){

    if(this.useType === 'employee') {
      let hasContract = this.contractFilter != 'none';
      let hasProject = this.taskFilter != 'none';
      let hasLcat = this.laborRateFilter != 'none';
      let hasPop = this.popRateFilter != 'none';
      return hasContract && hasProject && hasLcat && hasPop;
    } else if(this.useType === 'subcontractor') {

      let hasContract = this.contractFilter != 'none';
      let hasProject = this.taskFilter != 'none';
      let hasLcat = this.laborRateFilter != 'none';
      let hasPop = this.popRateFilter != 'none';
      return hasContract && hasProject && hasLcat && hasPop;
    }

  }

  clearOptions() {
    this.contractFilter = 'none';
    this.customerFilter = 'none';
    this.taskFilter = 'none';
    this.laborRateFilter = 'none';
    this.popRateFilter = 'none';
    this.subcontractor = 'none';
    this.contractsForCustomer = [];
    this.projectsForContract = [];
    this.subcontract = 'none';
  }

  clearProjectOptions(){
    this.laborRateFilter = 'none';
    this.popRateFilter = 'none';
    this.subcontract = 'none'
  }


  setUse(use) {
    this.use = use;
    this.step++;
  }

  userHasChargeCode(userId) {
    let x = _.find(this.chargecode.users, {'id': userId} );
    return x ? true : false;
  }

  prepareProjectChargeCode() {

    if(this.useType === 'employee') {
      this.chargecode.name = this.customerFilter.shortName + "-" + this.contractFilter.shortName + "-" + this.taskFilter.number + "-" + this.laborRateFilter.laborCategory.shortName + "-" + this.popRateFilter.periodOfPerformance.name;
      this.chargecode.description = "This is a charge code for a " + this.laborRateFilter.laborCategory.name + " on the "+ this.contractFilter.contractName +" contract in support of the " + this.taskFilter.name + " project. This charge code is for the "+ this.popRateFilter.periodOfPerformance.name + " period of performance."  ;
    }

    if(this.useType === 'subcontractor') {
      this.chargecode.name = 'SUB-'+this.subcontract.number+"-"+this.customerFilter.shortName + "-" + this.contractFilter.shortName + "-" + this.taskFilter.number + "-" + this.laborRateFilter.laborCategory.shortName + "-" + this.popRateFilter.periodOfPerformance.name;
      this.chargecode.description = "This is a subcontractor charge code for a " + this.laborRateFilter.laborCategory.name + " on the "+ this.contractFilter.contractName +" contract in support of the " + this.taskFilter.name + " project. This charge code is for the "+ this.popRateFilter.periodOfPerformance.name + " period of performance."  ;
      this.chargecode.subkFlag = true;
    }

    this.chargecode.name = this.chargecode.name.replace(" ", "_");
    this.chargecode.taskOrder = this.taskFilter;
    this.chargecode.leaveType = false;
    this.chargecode.billable = true;
    this.chargecode.payable = true;
    this.chargecode.popRate = this.popRateFilter;
    this.chargecode.effectiveDate = moment(this.popRateFilter.periodOfPerformance.startDate).toDate();
    this.chargecode.expirationDate = moment(this.popRateFilter.periodOfPerformance.endDate).toDate();


    this.checkForExistingChargeCodeName();

    this.step = 2;
  }

  currency(value) {
    if(value) {
      return '$' + formatCurrency(value);
    } else {
      return undefined;
    }
  }

  prepareInternalChargeCode() {
    this.chargecode.leaveType = (this.chargecode.leaveType == 'true');

    if(!this.chargecode.leaveType) {
      this.chargecode.associatedLeaveType = null;
    }


    this.step = 2;
  }




  addUserToChargeCode(user) {
    this.chargecode.users.push(user);

    _.remove(this.activeUsers, function (u) {
        return u.id == user.id;
    });

    this.selectedUser = undefined;
  }

  removeUserFromChargeCode(user) {
    _.remove(this.chargecode.users, function (u) {
      return u.id == user.id;
    });

    this.activeUsers.push(user);
  }


  chargeCodeValid() {
    let hasName = this.chargecode.name && this.chargecode.name.length > 0 && this.codeExists == false;
    return hasName;
  }

  checkForExistingChargeCodeName() {
    let self = this;
    if(this.chargecode.name.length == 0){
      this.codeExists = undefined;
      return;
    }

    if(this.chargecode.name && this.chargecode.name.length > 0) {
      this.$http.get(self.$rootScope.apiHost + '/api/admin/chargecodes/name/' + this.chargecode.name, {withCredentials: true}).then(function (success) {
        self.codeExists = true;
      }, function (failure) {
        self.codeExists = false;
      });
    };

  }

  initializeData() {
    let self = this;
    this.chargecode = {};
    this.customers = [];
    this.customerFilter = 'none';
    this.contractFilter = 'none';
    this.taskFilter = 'none';
    this.laborRateFilter = 'none';
    this.subcontractorsForContract = [];
    this.popRateFilter = 'none';
    this.useType = 'none';
    this.subcontractor = 'none';
    this.subcontract = 'none';
    this.codeExists = undefined;
    this.step = 0

    this.$http.get(this.$rootScope.apiHost+"/api/admin/customers", {withCredentials: true}).then(function (success) {
      self.customers = success.data;
      self.chargecode = {
        leaveType: 'false',
        users: [],
        associatedLeaveType: 'none',
      };
    });

    this.$http.get(self.$rootScope.apiHost+"/api/leave/types", {withCredentials: true}).then(function (success) {
      self.leaveTypes = success.data;
      self.chargecode.associatedLeaveType = 'none';
    });

    this.$http.get(self.$rootScope.apiHost+'/api/admin/users/names?active=true', {withCredentials: true}).then(function (success) {
      self.activeUsers = success.data;
    });



  }


  loadActiveSubcontractEmployees() {
    let self = this;
    this.activeSubcontractEmployees = [];
    this.$http.get(self.$rootScope.apiHost+'/api/admin/subcontractors/'+this.subcontract.subcontractorId+"/employees", {withCredentials: true}).then(function (success) {
      self.activeSubcontractEmployees = success.data;
    });
  }

  proceedToUserAdd() {
    this.step = 3;
    if(this.useType === 'subcontractor') {
      this.loadActiveSubcontractEmployees();
    }
  }

  createChargeCode() {
    let self = this;

    let userIds = [];

    this.chargecode.users.forEach(function (user) {
      userIds.push(user.id);
    });

    this.chargecode.users = userIds;

    // TODO: Remove this once we are sure we don't need it anymore
    if(this.chargecode.associatedLeaveType) {
      this.chargecode.associatedLeaveType = this.chargecode.associatedLeaveType.id;
    }

    this.$http.post(self.$rootScope.apiHost + '/api/admin/chargecodes', this.chargecode, {withCredentials: true}).then(function (success) {
      self.toastr.success("Charge Code Created", "Charge Code Created Succesfully!");
      self.state.go("admin.chargecode-details", {'chargecodeId': success.data.id});
    }, function (failure) {
      self.toastr.error("Problem Creating Charge Code", "ERROR!")
    });

  }




}

export default ChargecodeCreateController;



// WEBPACK FOOTER //
// ./client/pages/admin/chargecode-create/chargecode-create.controller.js